import { useEffect, useState } from 'react'
import type { RelationRef } from '../timeline/types'
import { listRelationAgreements } from './api'
import type { RelationAgreements } from './types'

/**
 * The agreements of a relation, loaded again when `version` changes (the page shows the old answer
 * meanwhile). The page owns this so Overzicht, the tab, its count and the rhythm fact share one request.
 */
export function useRelationAgreements(relation: RelationRef, version: number): { data: RelationAgreements | null; failed: boolean } {
  const [loaded, setLoaded] = useState<{ scope: string; data: RelationAgreements | null; failed: boolean } | null>(null)
  const scope = `${relation.kind}:${relation.id}`
  useEffect(() => {
    let cancelled = false
    listRelationAgreements({ kind: relation.kind, id: relation.id })
      .then((answer) => {
        if (!cancelled) setLoaded({ scope, data: answer, failed: false })
      })
      .catch(() => {
        if (!cancelled) setLoaded((current) => ({ scope, data: current?.scope === scope ? current.data : null, failed: true }))
      })
    return () => {
      cancelled = true
    }
  }, [relation.kind, relation.id, scope, version])
  return loaded !== null && loaded.scope === scope ? { data: loaded.data, failed: loaded.failed } : { data: null, failed: false }
}
